export const switchSize = ({width, height}) => ({
    width: height,
    height: width,
});
